export default {
  state: {
    name: '',
    description: '',
    price: '',
    basePrice: '',
    quantity: '',
    isVisible: '',
    isActive: '',
    validMonth: '',
  },
  mutations: {
    createReward(state, payload) {
      _.forEach(state, function (value, key) {
        state[key] = payload[_.snakeCase(key)];
      });
    },
    updateRewardDescription(state, description) {
      state.description = description;
    },
    updateRewardName(state, name) {
      state.name = name;
    },
    updateRewardPrice(state, price) {
      state.price = price;
    },
    updateRewardBasePrice(state, basePrice) {
      state.basePrice = basePrice;
    },
    updateRewardQuantity(state, quantity) {
      state.quantity = quantity;
    },
    updateRewardIsVisible(state, isVisible) {
      state.isVisible = isVisible;
    },
    updateRewardIsActive(state, isActive) {
      state.isActive = isActive;
    },
    updateRewardValidMonth(state, validMonth) {
      state.validMonth = validMonth;
    },
  },
};
